import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "au-play-btn__circle" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "outerCircle" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "innerCircle" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-play-fill" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

import { hapticsImpactMedium } from 'util/device-util';
import { useModule } from 'src/modules/modules';


export default /*#__PURE__*/_defineComponent({
  __name: 'play-button',
  emits: ['click'],
  setup(__props, { emit }) {


const { audio } = useModule();

const handleClick = () => {
    hapticsImpactMedium();
    //audio.play('FX_menu_btn_play');
    emit('click');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "au-play-btn",
    onClick: handleClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("button", _mergeProps(_ctx.$attrs, { class: "au-play-btn__btn" }), _hoisted_5, 16)
    ])
  ]))
}
}

})